module.exports = "/assets/239a72fa1510e056532291f5fdd98ca7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/ZB.png
// module id = 3175
// module chunks = 0